import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { useState, useRef, useEffect } from 'react';
import { CODE_GROUP_ID, HOME_PATH } from '../../../constant/Constant';
import InputBox from '../../../component/InputBox';
import CodeUtil from '../../../util/CodeUtil';
import { useDispatch, useSelector } from 'react-redux';
import { actionJoinUsPhase3 } from '../../../module/body/main/JoinUsPhase3Module';
import ConfirmButtonBox from '../../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../../component/PopupRef';
import { useNavigate } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';
import TelNoInputBox from '../../../component/TelNoInputBox';
import PasswordInputBox from '../../../component/PasswordInputBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';

const JoinUsPhase3View = ({ setPhase }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const [userId, setUserId] = useState(queryData.userId);
    const [uid, setUid] = useState(queryData.uid);
    const [password, setPassword] = useState('');
    const [isPassword, setIsPassword] = useState(false);
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);

    const [userUniversityCd, setUserUniversityCd] = useState(queryData.userUniversityCd);
    const [userUniversityNm, setUserUniversityNm] = useState(
        CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, queryData.userUniversityCd),
    );
    const [majorDeptNm, setMajorDeptNm] = useState('');
    const [studentId, setStudentId] = useState('');
    const [userNm, setUserNm] = useState('');
    const [telNo, setTelNo] = useState('');

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        {
            !SessionStorageUtil.getAgreeAll() &&
                popupRef.current.openInfo(
                    '개인정보 수집에 동의하지 않아 개인정보 수집 동의 페이지로 이동 합니다.',
                    () => {
                        return function () {
                            setPhase(1);
                        };
                    },
                );
        }
        {
            (!userId || !uid) &&
                popupRef.current.openInfo(
                    '회원가입 이메일을 통해 접근하지 않아 개인정보 수집 동의 페이지로 이동 합니다.',
                    () => {
                        return function () {
                            setPhase(1);
                        };
                    },
                );
        }
    }, []);

    const inputValidation = () => {
        if (NullCheckUtil.isEmpty(userId)) {
            popupRef.current.openAlert('아이디를 확인해 주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(password) || !isPassword) {
            popupRef.current.openAlert('화면의 비밀번호 오류메시지를 확인 해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(passwordConfirm) || !isPasswordConfirm) {
            popupRef.current.openAlert('화면의 비밀번호 오류메시지를 확인 해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(userUniversityCd)) {
            popupRef.current.openAlert('소속대학을 확인 해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(majorDeptNm)) {
            popupRef.current.openAlert('전공(학과)를 입력해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(studentId)) {
            popupRef.current.openAlert('학번을 입력해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(userNm)) {
            popupRef.current.openAlert('이름을 입력해주세요.');
            return false;
        } else if (NullCheckUtil.isEmpty(telNo)) {
            popupRef.current.openAlert('전화번호를 입력해주세요.');
            return false;
        } else {
            return true;
        }
    };

    const handleConfirm = () => {
        if (inputValidation()) {
            dispatch(
                actionJoinUsPhase3({
                    data: {
                        userId,
                        pswd: btoa(password),
                        userUniversityCd,
                        email: userId,
                        majorDeptNm,
                        studentId,
                        userNm,
                        telNo,
                        uid,
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                navigate(HOME_PATH);
                            };
                        });
                    },
                }),
            );
        }
    };

    const changeStudentId = (value) => {
        const onlyNumber = value.replace(/[^0-9]/g, '');
        setStudentId(onlyNumber);
    };

    return (
        <>
            <div className='join-content'>
                <h3 className='sub-tit'>기본 정보 확인</h3>
                <div className='personal-info-box'>
                    <div className='info-check-box'>
                        <InputBox title='아이디' value={userId} disabled onChange={(e) => setUserId(e.target.value)} />
                        <ul className='explain-txt'>
                            <li>인증에 사용된 본교 이메일 주소가 아이디로 사용됩니다.</li>
                            <li>이메일 주소를 통해 학번, 학교 정보가 추출되어 등록됩니다.</li>
                        </ul>
                        <PasswordInputBox
                            setPassword={setPassword}
                            setIsPassword={setIsPassword}
                            setPasswordConfirm={setPasswordConfirm}
                            setIsPasswordConfirm={setIsPasswordConfirm}
                        />
                    </div>
                </div>
                <h3 className='sub-tit border-t'>사용자 정보 입력</h3>
                <div className='personal-info-box'>
                    <div className='info-form-wrap'>
                        <div className='info-form-row'>
                            <InputBox title='소속대학' value={userUniversityNm} disabled />
                            <InputBox
                                title='전공(학과)'
                                value={majorDeptNm}
                                onChange={(e) => setMajorDeptNm(e.target.value)}
                            />
                            <InputBox
                                title='학번'
                                value={studentId}
                                onChange={(e) => changeStudentId(e.target.value)}
                            />
                        </div>
                        <div className='info-form-row'>
                            <InputBox title='이름' value={userNm} onChange={(e) => setUserNm(e.target.value)} />
                            <TelNoInputBox title='휴대전화' value={telNo} setTelNo={setTelNo} focus={true} />
                        </div>
                    </div>
                    <ul className='explain-txt'>
                        <li>등록된 휴대폰 번호를 통해 수강신청 반려 및 확정시 안내 SMS 가 발송됩니다.</li>
                    </ul>
                </div>
                <div className='join-btn-box btn-wrap'>
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
                <PopupRef ref={popupRef} />
            </div>{' '}
        </>
    );
};

export default JoinUsPhase3View;
